"use client";
 
import classes from "./SearchInput.module.scss";
import Search from "@/assets/icons/Search";
import CrossIcon from "@/assets/icons/CrossIcon";
import React, { useEffect, useState } from "react";
import useDebounce from "@/hooks/helper/debounce";
import { searchCategory } from "@/actions/fetchQueryData";
import { fetchArticleByData } from "@/actions/admin/index";
import Link from "next/link";
 
const SearchInput = ({
  selectedTag,
  setSelectedTag,
  setSelectedTitle,
  setSearchVisbility
}: {
  selectedTag: string;
  setSelectedTag: React.Dispatch<React.SetStateAction<string>>;
  setSelectedTitle: React.Dispatch<React.SetStateAction<string>>;
  setSearchVisbility:React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const [value, setValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const [tags, setTags] = useState<any[]>([]);
  const [articles, setArticles] = useState<any[]>([]);
 
  const selectedTagData = tags.find((tag: any) => tag.slug === selectedTag);
 
  const debouncedUpdate = useDebounce((val: string) => {
    setDebouncedValue(val);
  }, 600);
 
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    debouncedUpdate(event.target.value);
  };
 
  const titleClickHandler = (article: any) => () => {
    setSelectedTitle(article.title);
  };

  const tagClickHandler =
    (receivedTag: any = {}) =>
    () => {
      setSelectedTag(receivedTag.slug);
    };
    
 
  const removeTagHandler = () => {
    setSelectedTag("");
  };
 
  const inputClearHandler = () => {
    setValue("");
    setDebouncedValue("");
    setSelectedTag("");
  };
 
  useEffect(() => {
    const fetchTagsAndArticles = async () => {
      try {
        // Fetch categories (existing functionality)
        const categoryData = await searchCategory(debouncedValue);
        setTags(categoryData || []);
 
        const params = {
          title: debouncedValue, // Ensure correct key
          limit: 10,
          page: 1,
        };
 
        // Fetch articles by title using query param (new functionality)
        if (debouncedValue) {
          const articleResponse = await fetchArticleByData(params);
          const articlesData = articleResponse?.data?.articles ?? [];
          setArticles(articlesData);
        } else {
          setArticles([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
 
    fetchTagsAndArticles();
  }, [debouncedValue]);
 
  return (
    <div>
      <div className={classes["search-input-container"]}>
        <div className={classes["search-icon-container"]}>
          <Search color="black" width="16" height="16" />
        </div>
 
        <div className={classes["tags-input-container"]}>
          {selectedTagData ? (
            <div className={classes["attached-tag-wrapper"]}>
              <div className={classes["attached-tag-container"]}>
                {selectedTagData?.name}
                <CrossIcon width={14} height={14} onClick={removeTagHandler} />
              </div>
            </div>
          ) : null}
 
          <input
            placeholder="Enter your search"
            value={value}
            onChange={handleChange}
            autoFocus
          />
        </div>
 
        <div
          className={classes["close-icon-container"]}
          onClick={inputClearHandler}
        >
          <CrossIcon />
        </div>
      </div>
 
      <div className={classes["suggested-tag-container"]}>
        {tags.map((tag: any, index) => (
          <div
            key={index}
            className={classes["tag-container"]}
            onClick={tagClickHandler(tag)}
          >
            {tag.name}
          </div>
        ))}
      </div>
 
      {articles.length > 0 && (
        <div className={classes["suggested-tag-container"]}>
          {articles.map((article: any, index) => (
            <Link href='/article/[slug]' className={classes["tag-container"]} as={`/article/${article.slug}`} key={index} onClick={()=>setSearchVisbility(false)}>
            <div key={index} onClick={titleClickHandler(article)} >
              {article.title}
            </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
 
export default SearchInput;